module.exports = __webpack_public_path__ + "static/img/sample-data-xls.10ab53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/sample-data-xls.png
// module id = dmcZ
// module chunks = 3